var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallHelpdesk = function SvgCallHelpdesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 54,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1F5C8",
    d: "m40.7 32.469 5.534-5.567h14.383V5.652h-35.75s5.85 3.534 8.05 7.084c1.95 3.133 1.817 8.916 1.817 8.916"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M40.7 33.72c-.283 0-.583-.1-.816-.3a1.26 1.26 0 0 1-.133-1.767l5.533-6.483a1.22 1.22 0 0 1 .95-.434h13.133V2.52H30.384a1.26 1.26 0 0 1-1.25-1.25c0-.684.567-1.25 1.25-1.25h30.233c.684 0 1.25.566 1.25 1.25v24.716a1.26 1.26 0 0 1-1.25 1.25h-13.8l-5.166 6.05c-.25.283-.6.433-.95.433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M51.834 15.654a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4M43.25 15.654a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.234 27.501c4.634 0 8.384-3.633 8.384-8.133s-3.75-8.134-8.384-8.134c-4.633 0-8.383 3.634-8.383 8.134s3.75 8.133 8.383 8.133"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M20.234 28.751c-5.316 0-9.633-4.2-9.633-9.383 0-5.184 4.317-9.384 9.633-9.384 5.317 0 9.634 4.2 9.634 9.384 0 5.183-4.317 9.383-9.634 9.383m0-16.25c-3.933 0-7.133 3.083-7.133 6.883s3.2 6.884 7.133 6.884c3.934 0 7.134-3.084 7.134-6.884s-3.2-6.883-7.134-6.883"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7F0",
    fillRule: "evenodd",
    d: "M21.185 32.285H19.6l-4.4 16.5 5.183 5.084 5.217-5.084z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7F0",
    fillRule: "evenodd",
    d: "m24.868 32.285-4.467 4.35-4.45-4.35",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M40.218 53.869h-2.5v-10.15c0-5.75-4.85-10.434-10.817-10.434H13.518C7.55 33.285 2.7 37.97 2.7 43.72v10.15h-2.5v-10.15c0-7.134 5.967-12.934 13.317-12.934h13.4c7.333 0 13.316 5.8 13.316 12.933v10.15zM20.851 23.286H5.901a1.24 1.24 0 0 1-1.233-1.034c-.034-.183-.05-.366-.084-.55a15 15 0 0 1-.116-1.933C4.45 11.286 11.55 4.402 20.285 4.402s15.833 6.9 15.833 15.384c0 .683-.05 1.366-.134 2.05a1.247 1.247 0 0 1-1.416 1.066 1.247 1.247 0 0 1-1.067-1.416c.084-.567.117-1.134.117-1.7 0-7.1-5.984-12.884-13.333-12.884S6.95 12.686 6.95 19.786c0 .333 0 .683.033 1.016h13.867c.684 0 1.25.567 1.25 1.25 0 .684-.566 1.25-1.25 1.25z"
  })));
};
export default SvgCallHelpdesk;